module.exports = __webpack_public_path__ + "img/call.fa2863b8.svg";